import { IRoleAccessIsAnyLang } from '../../../types/lang'
import { ERoleAccessIsAny } from '../../../types'

export const roleAccessIsAnyLang: IRoleAccessIsAnyLang = {
	role_access_is_any: {
		[ERoleAccessIsAny.Any]: 'Any_ua',
		[ERoleAccessIsAny.Custom]: 'Custom_ua',
	}
}